import React from 'react'
import java from "../assets/java.png";


const Experience = () => {
    return (
        <div
            name="experience"
            className="w-full h-fit bg-gradient-to-b from-black to-gray-800 p-4 text-white" id="contactrad"
        >
            <div className="flex flex-col p-4 justify-saround max-w-screen-lg mx-auto h-fit">
                <div className="pb-8">
                    <p className="text-4xl font-bold inline border-b-4 border-gray-500">
                        Experience <br />
                    </p><br />
                    <p>
                        <a href="https://sevarepublic.com/" target="_blank">Seva Infotech Pvt Ltd</a>::- [May 2023-June 2023] 
                    
                        <p className='f18' style={{fontSize:"19px"}}> <br /> Worked as an software developer intern with Angular <br />
                            and TypeScript for web development, specializing <br />in
                            seamless API integration and utilized tools like <br />Postman,
                            Git, etc.</p>
                            </p>
                    


                </div>
            </div>
        </div>
    )
}

export default Experience
